import {exeRequest} from '../utils/APIUtils'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAllChauffeurs : async  () => exeRequest(`/admin/chauffeurs`, "GET"),

    getDetailChauffeur: async (id) => exeRequest(`/admin/chauffeur/${id}`, "GET"),

    //  post: async (data) => exeRequest(`/admin/chants`, "POST", data),
}